import React, { useMemo } from "react";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { AUDIT_LOG_ACTION_OPTIONS } from "./systemConfigurationUtils";

const AuditLogsConfigPanel = ({ auditLogPolicy, updateAuditLogPolicy, toggleAuditLogAction }) => {
  const enabledCount = useMemo(
    () => (auditLogPolicy.actions || []).filter((item) => item.enabled !== false).length,
    [auditLogPolicy.actions]
  );

  return (
    <section className="system-config-panel">
      <div className="system-config-panel-head">
        <div>
          <h3>Audit log save / hide policy</h3>
          <p>Super users decide which audit events are saved. Read-only events stay hidden by default to avoid heavy noisy logs.</p>
        </div>
        <FactCheckIcon />
      </div>

      <div className="system-config-audit-summary">
        <label className="system-config-switch-card">
          <span>
            <strong>Enable audit logging</strong>
            <small>When disabled, no new audit rows are written. Existing rows are not deleted.</small>
          </span>
          <input
            type="checkbox"
            checked={auditLogPolicy.enabled !== false}
            onChange={(event) => updateAuditLogPolicy({ enabled: event.target.checked })}
          />
        </label>

        <label className="system-config-switch-card">
          <span>
            <strong>Save unknown future actions</strong>
            <small>Keep enabled so future backend actions do not silently disappear before the UI is updated.</small>
          </span>
          <input
            type="checkbox"
            checked={auditLogPolicy.saveUnknownActions !== false}
            onChange={(event) => updateAuditLogPolicy({ saveUnknownActions: event.target.checked })}
          />
        </label>
      </div>

      <div className="system-config-audit-meter">
        <strong>{enabledCount}</strong>
        <span>audit actions currently saved</span>
      </div>

      <div className="system-config-audit-grid">
        {AUDIT_LOG_ACTION_OPTIONS.map((option) => {
          const policyAction = (auditLogPolicy.actions || []).find((item) => item.action === option.action);
          const checked = policyAction ? policyAction.enabled !== false : option.defaultEnabled;
          return (
            <label className={`system-config-audit-card ${checked ? "enabled" : "disabled"}`} key={option.action}>
              <input
                type="checkbox"
                checked={checked}
                onChange={() => toggleAuditLogAction(option.action)}
              />
              <span>
                <strong>{option.label}</strong>
                <small>{option.description}</small>
                <em>{checked ? "Saved" : "Hidden"}</em>
              </span>
            </label>
          );
        })}
      </div>
    </section>
  );
};

export default AuditLogsConfigPanel;
